import React from 'react'; // TODO: check this

var NavContext = React.createContext(null);
NavContext.displayName = 'NavContext';
export default NavContext;